import { Component } from '@angular/core';
import { BasePluginMenuComponent } from './base.menu';

@Component({
    templateUrl: './signature.menu.html',
    standalone: false
})
export class InstallationSignatureMenuComponent extends BasePluginMenuComponent {}
